/**
 * Whether the root route sends this visit to `/welcome` (ISSUE-1406).
 *
 * Only a signed-out visitor who typed or tapped the bare app address, with
 * nothing after the slash, and who has not seen the tour in this browser.
 * Everything else skips it: a signed-in fan, any deep link (a pool invite,
 * a join link, a share link, a section like `/messages`), and even `/` with
 * a search or a hash, because that is somebody's link carrying somewhere to
 * go. Those land on sign-in with their redirect intact, exactly as before.
 */
import { getAuthState } from "../../auth/getAuthState";
import { isIntroTourSeen } from "./introTourStore";

export const WELCOME_PATH = "/welcome";

export function shouldShowIntroTour(location: { href: string }): boolean {
  if (location.href !== "/") return false;
  if (getAuthState().status === "signedIn") return false;
  return !isIntroTourSeen();
}
